// 园区总览
const zl = {
    '$zl_menu_button_rain': 'Rain',
    '$zl_menu_button_snow': 'Snow',
    '$zl_menu_button_roamScene': 'Roam',
    '$zl_menu_button_trafficIntersection': 'Monitor',
    '$zl_menu_button_trafficVideo': 'Video',
    '$zl_button_parkOverview': 'Overview',
    '$zl_button_parkPlanning': 'Plan',
    '$zl_button_parkConstruction': 'Construct',
    '$zl_button_parkInvestment': 'Attract Investment',
    '$zl_button_parkOperation': 'Operate',
    '$zl_button_parkBuilding': 'Building',
    '$zl_l1_title1': 'Overview of the park',
    '$zl_l1_title2': ' ',
    '$zl_l1_n_area': 'Total Area',
    '$zl_l1_n_useArea': 'Total Land Area',
    '$zl_l1_n_people': 'Number of people',
    '$zl_l1_n_entCount': 'Number of enterprises',
    '$zl_l1_u_people': ' ',
    '$zl_l1_u_entCount': ' ',
    '$zl_l2_title1': 'Total area of the park',
    '$zl_l2_title2': ' ',
    '$zl_l2_n_name1': 'Zone A:',
    '$zl_l2_n_name2': 'Zone B:',
    '$zl_l2_n_name3': 'Zone C:',
    '$zl_l3_title1': 'Park Enterprises',
    '$zl_l3_title2': ' ',
    '$zl_l3_title3': 'Total',
    '$zl_r1_title1': 'Park Information',
    '$zl_r1_title2': ' ',
    '$zl_r1_n_parkingCount': 'Parking Space',
    '$zl_r1_u_parkingCount': ' ',
    '$zl_r1_n_peple': 'People',
    '$zl_r1_u_peple': ' ',
    '$zl_r1_n_air': 'Air quality',
    '$zl_r1_n_temperature': 'Temperature',
    '$zl_r1_n_traffic': 'Traffic',
    '$zl_r1_n_weather': 'Weather',
    '$zl_r2_title1': 'Events',
    '$zl_r2_title2': ' ',
}
// 园区规划
const gh = {
    '$gh_menu_button_dk': 'Plot Plan',
    '$gh_menu_button_wg': 'Network Plan',
    '$gh_l1_title1': 'Park planning',
    '$gh_l1_title2': ' ',
    '$gh_l1_name': 'Area A',
    '$gh_l1_n_name': 'Area Plan',
    '$gh_l1_n_area': 'Total Area',
    '$gh_l1_n_building': 'Buildings',
    '$gh_l1_u_building': ' ',
    '$gh_l1_n_busRoutes': 'Bus Routes',
    '$gh_l1_u_busRoutes': ' ',
    '$gh_l1_n_busStations': 'Stations',
    '$gh_l1_u_busStations': '',
    '$gh_l2_title1': 'Area Planning',
    '$gh_l2_title2': ' ',
    '$gh_l2_title3': 'A 区',
    '$gh_l2_name1': 'Building Land',
    '$gh_l2_name2': 'Greening Land',
    '$gh_l2_name3': 'Residential Land',
    '$gh_l2_name4': 'Business Land',
    '$gh_l2_name5': 'Transportation Land',
    '$gh_l2_name6': 'Water Land',
    '$gh_r1_title1': 'Land Planning',
    '$gh_r1_title2': ' ',
    '$gh_r1_n_building': 'Building',
    '$gh_r1_n_virescence': 'Greening',
    '$gh_r1_n_live': 'Residential',
    '$gh_r1_n_business': 'Business',
    '$gh_r1_n_traffic': 'Transportation',
    '$gh_r1_n_water': 'Water',
    '$gh_r2_title1': 'Facilities Planning',
    '$gh_r2_title2': ' ',
    '$gh_r2_n_name1': 'Firefighting',
    '$gh_r2_n_name2': 'Parking',
    '$gh_r2_n_name3': 'Fitness',
    '$gh_r2_n_name4': 'Camera',
    '$gh_r2_n_name5': 'Lighting',
    '$gh_r3_title1': 'Pipe Planning',
    '$gh_r3_title2': ' ',
    '$gh_r3_n_title': 'Manhole',
    '$gh_r3_n_unit': '(m)',
    '$gh_r3_n_unit2': ' ',
}
// 园区建设
const js = {
    '$js_menu_button_ly': 'Building',
    '$js_menu_button_xm': 'Project',
    '$js_l1_title1': 'Construction Progress',
    '$js_l1_title2': ' ',
    '$js_l1_n_name1': 'Park',
    '$js_l1_n_name2': 'Mall',
    '$js_l1_n_name3': 'Building',
    '$js_l1_n_name4': 'Road',
    '$js_l1_n_name5': 'Facilities',
    '$js_l2_title1': 'Detail',
    '$js_l2_title2': ' ',
    '$js_l2_n_name1': 'Region',
    '$js_l2_n_name2': 'Building',
    '$js_l2_n_name3': 'Area',
    '$js_l2_n_name4': 'Progress',
    '$js_l2_n_name5': 'Zone A',
    '$js_l2_n_name6': 'Zone B',
    '$js_l3_title1': 'Construction Project',
    '$js_l3_title2': ' ',
    '$js_l3_btn_text1': 'month',
    '$js_l3_unit': ' ',
    '$js_l3_btn_text2': 'day',
    '$js_r1_title1': 'Project Overview',
    '$js_r1_title2': ' ',
    '$js_r1_name1': 'Ordinary',
    '$js_r1_name2': 'Common',
    '$js_r1_name3': 'Keynote',
    '$js_r1_name4': 'ActiveProject',
    '$js_r1_name5': 'Completed',
    '$js_r1_name6': 'To be built',
    '$js_r2_title1': 'Pipeline Construction',
    '$js_r2_title2': ' ',
    '$js_r2_n_name1': 'Class A',
    '$js_r2_n_name2': 'Class B',
    '$js_r2_n_name3': 'Branch',
    '$js_r2_n_name4': 'Sewage',
    '$js_r2_n_name5': 'Manhole',
    '$js_r3_title1': 'Resource Usage',
    '$js_r3_title2': ' ',
    '$js_r3_name1': 'Concrete',
    '$js_r3_name2': 'Cement',
    '$js_r3_name3': 'Sandy Soil',
    '$js_r3_name4': 'Rebar',
}

// 园区招商
export const zs = {
    '$zs_menu_button_zlqk': 'Lease Situation',
    '$zs_menu_button_ggw': 'Advertisement',
    '$zs_menu_button_tcc': 'Parking',
    '$zs_menu_button_yqfw': 'Park Services',
    '$zs_l1_title1': 'Current situation of the park',
    '$zs_l1_title2': ' ',
    '$zs_l1_n_area': 'Total area of the park',
    '$zs_l1_n_useArea': 'Self use area',
    '$zs_l1_n_rentedArea': 'Rented Area',
    '$zs_l1_n_notRentedArea': 'Area to be leased',
    '$zs_l2_title1': 'Regional Leasing',
    '$zs_l2_title2': ' ',
    '$zs_l2_zone': 'A',
    '$zs_l2_zmj': 'Total Area',
    '$zs_l2_zymj': 'Self Use Area',
    '$zs_l2_zhuymj': 'Lettable Area',
    '$zs_l2_yczmj': 'Rented Area',
    '$zs_l2_wczmj': 'Unleased Area',
    '$zs_r1_title1': 'Settled Enterprise',
    '$zs_r1_title2': ' ',
    '$zs_r1_n_name1': 'Name',
    '$zs_r1_n_name2': 'Corporation',
    '$zs_r1_n_name3': 'Size',
    '$zs_r1_n_name4': 'Area',
    '$zs_r2_title1': 'Park Leasing',
    '$zs_r2_title2': ' ',
    '$zs_r2_n_name1': 'Self Use',
    '$zs_r2_n_name2': 'Rented',
    '$zs_r2_n_name3': 'For Rent',
    '$zs_r3_title1': 'Value Tax',
    '$zs_r3_title2': ' ',
    '$zs_r3_n_name1': 'Output',
    '$zs_r3_n_name2': 'Taxation',
    '$zs_r4_title1': 'Rental Price',
    '$zs_r4_title2': ' ',
    '$zs_r4_n_name1': 'Leasing price',
}

// 原区运营
export const yy = {
    '$yy_menu_button_rstj': 'People Counting',
    '$yy_menu_button_yye': 'Turnover',
    '$yy_menu_button_zdqy': 'Key Enterprises',
    '$yy_l1_title1': 'Park Environment',
    '$yy_l1_title2': ' ',
    '$yy_l1_n_temperature': 'Temp',
    '$yy_l1_n_humidity': 'Humidity',
    '$yy_l1_n_pm': 'PM',
    '$yy_l2_title1': 'Operations Overview',
    '$yy_l2_title2': ' ',
    '$yy_l2_n_area': 'Total area of the park',
    '$yy_l2_n_rentalArea': 'Rentable area',
    '$yy_l2_n_occupancyRate': 'Enterprise occupancy rate',
    '$yy_l2_n_vacancyRate': 'Vacancy Rate',
    '$yy_l3_title1': 'Park Enterprises',
    '$yy_l3_title2': ' ',
    '$yy_l3_tj_name1': 'Registered:',
    '$yy_l3_tj_name2': 'Check-in:',
    '$yy_l3_lx_name1': 'Enterprise Type',
    '$yy_l3_lx_name2': 'Industry Type',
    '$yy_r1_title1': 'Park Facilities',
    '$yy_r1_title2': ' ',
    '$yy_r1_n_title1': 'Camera',
    '$yy_r1_n_title2': 'Bayonet 1',
    '$yy_r1_n_title3': 'Bayonet 2',
    '$yy_r1_n_title4': 'Bayonet 3',
    '$yy_r1_n_cameraOnline': 'Online',
    '$yy_r1_n_cameraOffline': 'Offline',
    '$yy_r1_n_cameraAlarm': 'Alarms',
    '$yy_r1_n_value1': 'Normal',
    '$yy_r1_n_value2': 'Congestion',
    '$yy_r1_n_value3': 'Normal',
    '$yy_r2_title1': 'Parking Space Statistics',
    '$yy_r2_title2': ' ',
    '$yy_r2_n_title1': 'Parking Total',
    '$yy_r2_n_title2': 'Regular Model',
    '$yy_r2_n_title3': 'New Energy',
    '$yy_r2_n_used': 'Used',
    '$yy_r2_n_free': 'Free',
    '$yy_r2_n_normalCarTotal': 'Total',
    '$yy_r2_n_normalCarFree': 'Free',
    '$yy_r2_n_newEnergyCarTotal': 'Total',
    '$yy_r2_n_newEnergyCarFree': 'Free',
    '$yy_r3_title1': 'Vehicle Access',
    '$yy_r3_title2': ' ',
    '$yy_r3_unit': ' ',
    '$yy_r3_name1': 'Enter',
    '$yy_r3_name2': 'Out',
}

// 园区楼宇
export const ly = {
    '$ly_menu_button_dtxt': 'Elevator',
    '$ly_menu_button_zmxt': 'Lighting',
    '$ly_menu_button_xfxt': 'Fire Fighting',
    '$ly_menu_button_afxt': 'Security',
    '$ly_menu_button_hjyktxt': 'Air Conditioning',
    '$ly_l1_title1': 'Building Information',
    '$ly_l1_title2': ' ',
    '$ly_l1_sub_title': 'Building Introduction',
    '$ly_l1_airQuality': 'Air Quality',
    '$ly_l1_n_airQuality': 'Good',
    '$ly_l1_n_peopleOutIn': 'Personnel',
    '$ly_l1_n_ele': 'Elec',
    '$ly_l1_n_water': 'Water',
    '$ly_l1_u_water': '(ton)',
    '$ly_l2_title1': 'Personnel Access',
    '$ly_l2_title2': ' ',
    '$ly_l2_unit': '（number）',
    '$ly_l2_name1': 'Enter',
    '$ly_l2_name2': 'Out',
    '$ly_l3_title1': 'Entry and exit methods',
    '$ly_l3_title2': ' ',
    '$ly_l3_name1': 'Scanning',
    '$ly_l3_name2': 'WeChat',
    '$ly_l3_name3': 'IC card',
    '$ly_l3_value1': '30%  55',
    '$ly_l3_value2': '30%   55',
    '$ly_l3_value3': '40%    30',
    '$ly_r1_title1': 'Energy Analysis',
    '$ly_r1_title2': ' ',
    '$ly_r1_n_totalEnergy': 'Total Energy',
    '$ly_r1_n_energyRatio': 'Ratio',
    '$ly_r1_n_totalLoad': 'Total Load',
    '$ly_r2_title1': 'Real Time Staff',
    '$ly_r2_title2': ' ',
    '$ly_r2_n_totalPopulation': 'Total',
    '$ly_r2_n_name1': 'Staff',
    '$ly_r2_n_name2': 'Security',
    '$ly_r2_n_name3': 'Visitor',
    '$ly_r2_n_unit': ' ',
    '$ly_r3_title1': 'Traffic Analysis',
    '$ly_r3_title2': ' ',
    '$ly_r3_n_staff': 'Employed',
    '$ly_r3_n_flow': 'Flow',
    '$ly_r3_unit': '（people）',
}
// 园区楼宇-电梯
const ly_dt = {
    '$ly_dt_l1_title1': 'Elevator',
    '$ly_dt_l1_title2': ' ',
    '$ly_dt_l1_title3': 'Elevator Monitoring',
    '$ly_dt_l1_name1': 'Normal',
    '$ly_dt_l1_name2': 'Fault',
    '$ly_dt_l1_elevator1': '1#',
    '$ly_dt_l1_elevator2': '2#',
    '$ly_dt_l1_elevator3': '3#',
    '$ly_dt_l1_elevator4': '4#',
    '$ly_dt_r1_title1': 'Total Work',
    '$ly_dt_r1_title2': ' ',
    '$ly_dt_r1_panel_title1': 'Operating Mileage',
    '$ly_dt_r1_panel_util1': 'km',
    '$ly_dt_r1_panel_title2': 'Number of people',
    '$ly_dt_r1_panel_util2': ' ',
    '$ly_dt_r1_panel_title3': 'Elevator Door',
    '$ly_dt_r1_panel_util3': 'Times',
    '$ly_dt_r1_panel_title4': 'Waiting Time',
    '$ly_dt_r1_panel_title5': 'Failure Freq',
    '$ly_dt_r1_panel_util5': 'Times',
    '$ly_dt_r1_panel_title6': 'Inspection Freq',
    '$ly_dt_r1_panel_util6': 'Times',
    '$ly_dt_r2_title1': 'Equipment Operation',
    '$ly_dt_r2_title2': ' ',
    '$ly_dt_r2_panel1_name': 'Regular Elevator',
    '$ly_dt_r2_panel1_n_runNumber': 'Run',
    '$ly_dt_r2_panel1_n_stopNumber': 'Stop',
    '$ly_dt_r2_panel1_n_faultNumber': 'Fault',
    '$ly_dt_r2_panel2_name': 'Fire Elevators',
    '$ly_dt_r2_panel2_n_runNumber': 'Run',
    '$ly_dt_r2_panel2_n_stopNumber': 'Stop',
    '$ly_dt_r2_panel2_n_faultNumber': 'Fault',
    '$ly_dt_r3_title1': 'Elevator Alarm',
    '$ly_dt_r3_title2': ' ',
    '$ly_dt_r3_chart_title': 'Alarm trend chart for this month',
    '$ly_dt_r3_chart_unit': '（time）',
}
// 园区楼宇-照明
const ly_zm = {
    '$ly_zm_l1_title1': 'Lighting Control',
    '$ly_zm_l1_title2': ' ',
    '$ly_zm_l1_name': 'First floor',
    '$ly_zm_l1_model1': 'Work Mode',
    '$ly_zm_l1_model2': 'Off Duty Mode',
    '$ly_zm_l1_model3': 'Rest Mode',
    '$ly_zm_l1_n_total': 'Total',
    '$ly_zm_l1_n_openNumber': 'Status - On',
    '$ly_zm_l1_n_closeNumber': 'Status - Off',
    '$ly_zm_l2_title1': 'Ambient Illuminance',
    '$ly_zm_l2_title2': ' ',
    '$ly_zm_l2_panel_title': 'Illuminance Trend Chart',
    '$ly_zm_l2_panel_name': 'Current',
    '$ly_zm_l3_title1': 'Environmental Conditions',
    '$ly_zm_l3_title2': ' ',
    '$ly_zm_l3_panel_name1': 'Region',
    '$ly_zm_l3_panel_name2': 'Sensor',
    '$ly_zm_l3_panel_name3': 'Value',
    '$ly_zm_r1_title1': 'Lighting Energy',
    '$ly_zm_r1_title2': '',
    '$ly_zm_r1_chart_title': 'Energy Consumption Trend Chart',
    '$ly_zm_r1_chart_unit': '(degree)',
    '$ly_zm_r2_title1': 'Indoor Lighting',
    '$ly_zm_r2_title2': ' ',
    '$ly_zm_r2_button1': 'Indoor',
    '$ly_zm_r2_button2': 'Street Lamp',
    '$ly_zm_r2_model': 'Mode: Daytime',
    '$ly_zm_r2_n_lightTotal': 'Total',
    '$ly_zm_r2_n_lightOpenNumber': 'On',
    '$ly_zm_r2_n_lightCloseNumber': 'Off',
    '$ly_zm_r2_n_name1': 'Points',
    '$ly_zm_r2_n_name2': 'Mode',
    '$ly_zm_r2_n_name3': 'Running State',
    '$ly_zm_r2_n_item1': 'Garage',
    '$ly_zm_r2_n_item2': 'Entrance Lobby',
    '$ly_zm_r2_n_item3': 'Public Areas',
    '$ly_zm_r2_n_status1': 'Normal',
    '$ly_zm_r2_n_status2': 'Fault',
    '$ly_zm_r2_n_status3': 'Stop',
    '$ly_zm_r3_title1': 'Elevator Alarm',
    '$ly_zm_r3_title2': '',
    '$ly_zm_r3_n_number': 'Number:',
}
// 园区楼宇-消防
const ly_xf = {
    '$ly_xf_l1_title1': 'Fire Fighting Operation',
    '$ly_xf_l1_title2': ' ',
    '$ly_xf_l1_n_fireEngine': 'Fire Engine',
    '$ly_xf_l1_n_status': 'Normal',
    '$ly_xf_l1_n_time': 'Last Reset Time',
    '$ly_xf_l1_time': '2019-07-18',
    '$ly_xf_l1_p2_n_firePath': 'Fire Escape',
    '$ly_xf_l1_p2_n_status': 'Normal',
    '$ly_xf_l1_p2_n_time': 'Last Reset Time',
    '$ly_xf_l1_p2_time': '2019-07-18',
    '$ly_xf_l1_p3_title': 'Smoke Detector',
    '$ly_xf_l1_p3_unit': ' ',
    '$ly_xf_l1_p3_item1_name': 'Running',
    '$ly_xf_l1_p3_item1_unit': '',
    '$ly_xf_l1_p3_item2_name': 'Offline',
    '$ly_xf_l1_p3_item2_unit': ' ',
    '$ly_xf_l1_p3_item3_name': 'Fault',
    '$ly_xf_l1_p3_item3_unit': ' ',
    '$ly_xf_l1_p4_title': 'Electric Fire',
    '$ly_xf_l1_p4_unit': ' ',
    '$ly_xf_l1_p4_item1_name': 'Running',
    '$ly_xf_l1_p4_item1_unit': ' ',
    '$ly_xf_l1_p4_item2_name': 'Offline',
    '$ly_xf_l1_p4_item2_unit': ' ',
    '$ly_xf_l1_p4_item3_name': 'Fault',
    '$ly_xf_l1_p4_item3_unit': ' ',
    '$ly_xf_l2_title1': 'High Risk Fire Insurance',
    '$ly_xf_l2_title2': ' ',
    '$ly_xf_r1_title1': 'Fire Engine',
    '$ly_xf_r1_title2': ' ',
    '$ly_xf_r1_p1_title': 'Host Monitoring',
    '$ly_xf_r1_p1_n_airQuality': 'Air Quality',
    '$ly_xf_r1_p1_status': 'Normal',
    '$ly_xf_r1_p1_n_time': 'Last Reset Time',
    '$ly_xf_r1_p2_text': 'Channel Monitoring',
    '$ly_xf_r1_p2_n_status': 'Current Switch Status ',
    '$ly_xf_r1_p2_status': 'Closed',
    '$ly_xf_r1_p2_n_time': 'Last Checked',
    '$ly_xf_r2_title1': 'Smoke Sensor',
    '$ly_xf_r2_title2': ' ',
    '$ly_xf_r2_n_total': 'Total',
    '$ly_xf_r2_n_online': 'Online',
    '$ly_xf_r2_button_text': 'Viewing Trends',
    '$ly_xf_r3_title1': 'Fire Alarm',
    '$ly_xf_r3_title2': ' ',
    '$ly_xf_r3_name1': 'Electrical',
    '$ly_xf_r3_name2': 'Smoke',
    '$ly_xf_r3_name3': 'Manual',
    '$ly_xf_r3_name4': 'Other',
    '$ly_xf_r4_title1': 'Fire Pressure',
    '$ly_xf_r4_title2': ' ',
    '$ly_xf_r4_name1': 'Normal',
    '$ly_xf_r4_name2': 'Abnormal',
    '$ly_xf_r4_name3': 'Offline',
}
// 园区楼宇-安防系统
const ly_af = {
    '$ly_af_floor_1': '1 layer',
    '$ly_af_floor_2': '2 layer',
    '$ly_af_floor_3': '3 layer',
    '$ly_af_floor_4': '4 layer',
    '$ly_af_floor_5': '5 layer',
    '$ly_af_floor_6': '6 layer',
    '$ly_af_floor_7': '7 layer',
    '$ly_af_floor_8': '8 layer',
    '$ly_af_floor_9': '9 layer',
    '$ly_af_floor_10': '10 layer',
    '$ly_af_floor_11': '11 layer',
    '$ly_af_floor_12': '12 layer',
    '$ly_af_floor_13': '13 layer',
    '$ly_af_floor_14': '14 layer',
    '$ly_af_floor_15': '15 layer',
    '$ly_af_floor_16': '16 layer',
    '$ly_af_floor_17': '17 layer',
    '$ly_af_floor_18': '18 layer',
    '$ly_af_r1_title1': 'Traffic Monitoring',
    '$ly_af_r1_title2': ' ',
    '$ly_af_r1_n_staff': 'Staff',
    '$ly_af_r1_n_visitor': 'Visitor',
    '$ly_af_r1_n_security': 'Security',
    '$ly_af_r2_title1': 'Intraday Flow',
    '$ly_af_r2_title2': ' ',
    '$ly_af_r2_unit': '（number）',
    '$ly_af_r2_info': '14:00  250人',
    '$ly_af_r2_tab1': 'Gate',
    '$ly_af_r2_tab2': 'Access',
    '$ly_af_r2_tab3': 'Parking',
    '$ly_af_r2_item1': 'Total',
    '$ly_af_r2_item2': 'Online',
    '$ly_af_r2_item3': 'Alarm',
    '$ly_af_r3_title1': 'Video Monitoring',
    '$ly_af_r3_title2': ' ',
    '$ly_af_r3_item1': 'Prevent',
    '$ly_af_r3_item2': 'Alarm',
    '$ly_af_r3_name1': 'Camera',
    '$ly_af_r3_name2': 'Storage',
    '$ly_af_r3_name3': 'Decoder',
}
// 园区楼宇-环境与空调系统
const ly_hj = {
    '$ly_hj_l1_title1': 'Environment Monitoring',
    '$ly_hj_l1_title2': ' ',
    '$ly_hj_l1_n_temperature': 'Temperature',
    '$ly_hj_l1_n_pm25': 'PM2.5',
    '$ly_hj_l1_n_humidity': 'Humidity',
    '$ly_hj_l1_n_windSpeed': 'Wind Speed',
    '$ly_hj_l2_title1': 'Real-time Curve',
    '$ly_hj_l2_title2': ' ',
    '$ly_hj_l3_title1': 'Indoor Environment',
    '$ly_hj_l3_title2': ' ',
    '$ly_hj_l3_name1': 'Monit',
    '$ly_hj_l3_name2': 'Tem ℃',
    '$ly_hj_l3_name3': 'Hum%',
    '$ly_hj_l3_name4': 'Dew Td',
    '$ly_hj_l3_name5': 'ppm',
    '$ly_hj_r1_title1': 'Real-time Monitoring',
    '$ly_hj_r1_title2': ' ',
    '$ly_hj_r1_p_title': 'Real-time Monitoring',
    '$ly_hj_r2_title1': 'Air Conditioning Load',
    '$ly_hj_r2_title2': ' ',
    '$ly_hj_r2_unit1': 'digits/hour',
    '$ly_hj_r2_unit2': 'unit： kw/h',
    '$ly_hj_r3_title1': 'Water Cooling',
    '$ly_hj_r3_title2': ' ',
    '$ly_hj_r3_p_status': 'Run',
    '$ly_hj_r3_p_working': 'Heat',
    '$ly_hj_r3_p_c1Status': 'Enable',
    '$ly_hj_r3_p_c2Status': 'Enable',
    '$ly_hj_r3_p_n_power': 'Power',
    '$ly_hj_r3_p_n_electricity': 'Electricity',
    '$ly_hj_r3_p_n_working': 'Conditions',
    '$ly_hj_r3_p_n_status': 'Status',
    '$ly_hj_r3_p_n_c1Status': 'C1 Status',
    '$ly_hj_r3_p_n_c2Status': 'C2 Status',
    '$ly_hj_r4_title1': 'VRV System',
    '$ly_hj_r4_title2': ' ',
    '$ly_hj_r4_p_status': 'Run',
    '$ly_hj_r4_p_working': 'Heat',
    '$ly_hj_r4_p_c1Status': 'Enable',
    '$ly_hj_r4_p_c2Status': 'Enable',
    '$ly_hj_r4_p_n_power': 'Power',
    '$ly_hj_r4_p_n_electricity': 'Electricity',
    '$ly_hj_r4_p_n_working': 'Conditions',
    '$ly_hj_r4_p_n_status': 'Status',
    '$ly_hj_r4_p_n_c1Status': 'C1 Status',
    '$ly_hj_r4_p_n_c2Status': 'C2 Status',
}

// 楼宇招商3d
export const zs3d = {
    '$zs3d_lease_n_price': 'Average: ',
    '$zs3d_ad_title': 'Billboard',
    '$zs3d_parking_n_total': 'Total',
    '$zs3d_parking_n_used': 'Used',
    '$zs3d_parking_n_remain': 'Free',
    '$zs3d_parking_n_inNumber': 'Input',
    '$zs3d_parking_n_outNumber': 'Output',
    '$zs3d_parking_n_faultNumber': 'Abnormal',
}

// 园区运营3d
const yy3d = {
    '$yy3d_rstj_n_inNumber': 'Enter',
    '$yy3d_rstj_n_outNumber': 'Exit',
    '$yy3d_yye_name': 'Turnover',
    '$yy3d_zdqy_title': 'Key Enterprises',
    '$yy3d_zdqy_name1': 'Name',
    '$yy3d_zdqy_name2': 'Legal Person',
    '$yy3d_zdqy_name3': 'Scale',
}

export default {
    '$title': 'Hightopo Smart Park Intelligent Operation Center IOC',

    ...zl,
    ...gh,
    ...js,
    ...zs,
    ...yy,
    ...ly,
    ...ly_dt,
    ...ly_zm,
    ...ly_xf,
    ...ly_af,
    ...ly_hj,

    ...zs3d,
    ...yy3d,
}